/* eslint-disable jsx-a11y/media-has-caption */
import { FileTextOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import Image from 'next/image';
import fa from 'locales/fa.json';
import { maxLengthError, minLengthError } from './common.util';
import AudioMessage from 'components/Common/AudioMessage';

export const TeacherAvatar = ({ teacher, size = 30 }): JSX.Element => {
  return teacher?.avatar ? (
    <Image
      src={teacher.avatar}
      width={size}
      height={size}
      alt={teacher.nickname}
      className="rounded-full"
    />
  ) : (
    <Avatar
      style={{ backgroundColor: '#87d068' }}
      icon={<UserOutlined style={{ fontSize: size / 1.6 }} />}
      size={size}
    />
  );
};

export const handleError = (error, rules): JSX.Element =>
  !!error && (
    <span className="text-red-0 text-[10px] absolute bottom-[-16px] right-2">
      {error?.type === 'required'
        ? fa.account.emptyField
        : error?.type === 'minLength'
        ? minLengthError(rules.minLength)
        : error?.type === 'maxLength'
        ? maxLengthError(rules.minLength)
        : error.message}
    </span>
  );

export const fileRenderer = (path, type): JSX.Element => {
  const src = typeof path === 'string' ? path : path && URL.createObjectURL(path);
  const render = {
    image: <Image src={src} width={200} height={200} alt="" />,
    audio: <AudioMessage audioUrl={src} />,
    video: (
      <div className="video-container max-w-[300px]">
        <video controls>
          <source src={src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    ),
    file: (
      <div
        onClick={(): void => {
          window.open(path);
        }}
        className="bg-gray-4 rounded-full w-[60px] cursor-pointer h-[60px] center"
      >
        <FileTextOutlined style={{ fontSize: '30px' }} />
      </div>
    ),
  };

  return <div className="">{render?.[type]}</div>;
};
